import { AddressChangerPuppeteerStatus, AddressChangerSocketEventNames, useAddressChangerSocket } from '@/modules/AddressChanger';

interface Data {
  status: AddressChangerPuppeteerStatus;
}

interface Args {
  handleSetStateStatus: (status: AddressChangerPuppeteerStatus) => void;
}

export const useUpdateAddressChangingServiceState = ({
  handleSetStateStatus
}: Args) => {
  useAddressChangerSocket<Data>(AddressChangerSocketEventNames.PuppeteerHealth, ({ lastMessage },) => {
    const { status } = lastMessage;

    handleSetStateStatus(status);
  }, {
    onMount: (socket) => {
      // socket.connect();
      socket.emit(AddressChangerSocketEventNames.PuppeteerHealth, (data: Data) => {
        handleSetStateStatus(data.status);
      });
    },
    // onUnmount: (socket) => {
    //   socket.disconnect();
    // },
    onConnect: (socket) => {
      socket.emit('puppeteerHealth', (data: Data) => {
        handleSetStateStatus(data.status);
      });
    },
    onDisconnect: () => {
      handleSetStateStatus(AddressChangerPuppeteerStatus.Closed);
    },
    onError: () => {
      handleSetStateStatus(AddressChangerPuppeteerStatus.Error);
    }
  });
};

